// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"4361":"202093b7","5218":"43c4be61","5723":"25ea48e9","9894":"1952ba59"}[chunkId] + ".chunk.css";
};